function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyCmt = function SvgEmptyCmt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34.002,
    viewBox: "0 0 43 34.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 15250"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 45716",
    d: "M170.766 104.92h-.846a.346.346 0 0 0-.346.346v12.764c0 2.043-1.187 3.888-3.571 3.888h-22.96a.383.383 0 0 0-.383.383v.24c0 1.806 2.052 3.626 4.16 3.626h17.592a.934.934 0 0 1 .475.129l5.9 3.469a.345.345 0 0 0 .51-.38l-.732-2.964a.205.205 0 0 1 .2-.254c2.106 0 3.056-1.819 3.056-3.626v-14.509a2.809 2.809 0 0 0-3.056-3.112z",
    transform: "translate(-130.821 -95.812)",
    style: {
      fill: "#c2c9d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 45717",
    d: "M32.241 0H5.13C2.745 0 0 2.119 0 4.162v16.43c0 1.772 2.063 3.079 4.167 3.4a.354.354 0 0 1 .286.441l-1.13 4.291a.352.352 0 0 0 .519.393l8.237-4.845a1.4 1.4 0 0 1 .71-.194h19.452c2.384 0 4.587-1.446 4.587-3.487V4.162c0-2.043-2.2-4.162-4.587-4.162zM9.267 13.87a2.449 2.449 0 1 1 2.449-2.45 2.416 2.416 0 0 1-2.449 2.449zm9.347-.008a2.449 2.449 0 1 1 2.242-2.242 2.449 2.449 0 0 1-2.243 2.242zm8.95.008a2.449 2.449 0 1 1 2.449-2.449 2.415 2.415 0 0 1-2.45 2.449z",
    style: {
      fill: "#c2c9d5"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyCmt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_cmt.3ab19b8e.svg";
export { ForwardRef as ReactComponent };